import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { useReduxStore } from '../hooks/useReduxStore';
import { updateItem } from '../store/Reducers/itemReducer';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid';
import SubscriptionStatusBadge from './SubscriptionStatusBadge';
import { CancelSubscription } from '../store/Actions/action';
const featuresLabelMap = {
  locations: 'Locations',
  currentConditions: 'Current Conditions',
  forecastDaily: 'Daily Forecast (Days)',
  forecastHourly: 'Hourly Forecast (Hours)',
  indices: 'Indices',
  alarms: 'Alarms',
  translations: 'Multi-language Support',
  tropical: 'Tropical Storm Data',
  alerts: 'Weather Alerts',
  imagery: 'Radar & Satellite Imagery',
};

const PricingCard = ({ plan,onClickCard,planeId ,isCancelled,mySubscription,isAdminCreated}) => {
  const {dispatch,getState}=useReduxStore()
  const {token}=getState("AUTH")
  const navigate=useNavigate()
  const featureList = Object.entries(plan.features);
  const isSubscribed=planeId===plan._id
const onClick=()=>{
  if(plan.name === 'Custom'){
    onClickCard(plan);
    return;
  }
if(!isSubscribed){
    dispatch(updateItem({itemDetail:{...plan}}))
  onClickCard(plan)
}
  //  navigate("/Checkout",)
  }
  const onCancel=()=>{
    // console.log("plan -------",plan)
    dispatch(CancelSubscription({id:mySubscription?._id}))
  }
  const isDownGrade=mySubscription?._id&&mySubscription?.planId?.price>plan?.price
  return (
    token&&plan?.price===0 && plan?.name !== 'Custom'?
      <div  className="flex flex-col justify-between min-h-[550px] bg-[#212C43] border border-[#4A5567] rounded-lg shadow-sm   ">
      <div className="p-4 md:p-6 md:py-8 flex flex-col flex-1 text-center">
        {/* Header */}
        <div className="mb-4">
          <h3 className="text-xs font-semibold text-white bg-[#3662E3] px-3 py-1 rounded-full inline-block">{plan.name}</h3>
        </div>

        {/* Price */}
        <div className="flex items-baseline justify-center mb-5 mt-2">
          <span className="text-4xl font-bold text-[#3662E3]">
            {plan.price === 0 ? '$0' : `$${plan.price}`}
          </span>
          <span className="text-xs text-gray-300 ml-1">
            {plan.interval === 'none' ? '' : `/${plan.interval}`}
          </span>
        </div>

        {/* Line below price */}
        <div className="w-full h-[0.8px] bg-[#4A5567] mb-4"></div>

        {/* Features Heading */}
        <div className="mb-4">
          <h4 className="text-lg font-semibold text-white">Features</h4>
        </div>

        {/* Features */}
        <ul className="space-y-3 text-sm font-light  text-white flex-1 overflow-y-auto pr-1">
          {featureList.map(([key, value]) => (
            <li key={key} className={`flex items-start justify-center ${value ? '' : 'opacity-50'}`}>
              {value ? (
                <CheckIcon className="w-4 h-4 text-[#3662E3] mr-2 mt-0.5" />
              ) : (
                <XMarkIcon className="w-4 h-4 text-gray-400 mr-2 mt-0.5" />
              )}
              <span>
                {typeof value === 'boolean'
                  ? key
                  : `${key}`}
              </span>
            </li>
          ))}
        </ul>

        {/* Line below features */}
        <div className="w-full h-[0.8px] bg-[#4A5567] mt-4"></div>

        {/* Button */}
 {  isAdminCreated?null:     <button className="w-2/3 mx-auto  mt-6 py-2 px-6 rounded-lg text-sm border hover:cursor-not-allowed text-white bg-[#3662E3] border-[#3662E3] font-medium transition-colors duration-300 ">
          {"Default"}
        </button>}
      </div>
    </div>:
    isSubscribed
    ?
  <div onClick={onClick} className="relative flex flex-col justify-between min-h-[550px] bg-[#212C43] border border-[#4A5567] rounded-lg shadow-sm   ">
      <div className="p-4 md:p-6 md:py-8 flex flex-col flex-1 text-center">
     
    {/* Header */}
<div className="mb-4">
  <div className="flex items-center justify-center">
    <h3 className="text-xs font-semibold text-white bg-[#3662E3] px-3 py-1 rounded-full inline-block">{plan.name}</h3>

   <SubscriptionStatusBadge isCancelled={isCancelled} />
  </div>
</div>

        {/* Price */}
        <div className="flex items-baseline justify-center mb-5 mt-2">
          <span className="text-4xl font-bold text-[#3662E3]">
            {plan.price === 0 ? '$0' : `$${plan.price}`}
          </span>
          <span className="text-xs text-gray-300 ml-1">
            {plan.interval === 'none' ? '' : `/${plan?.interval||"monthly"}`}
          </span>
        </div>

        {/* Line below price */}
        <div className="w-full h-[0.8px] bg-[#4A5567] mb-4"></div>

        {/* Features Heading */}
        <div className="mb-4">
          <h4 className="text-lg font-semibold text-white">Features</h4>
        </div>

        {/* Features */}
        <ul className="space-y-3 text-sm font-light  text-white flex-1 overflow-y-auto pr-1">
          {featureList.map(([key, value]) => (
            <li key={key} className={`flex items-start justify-center ${value ? '' : 'opacity-50'}`}>
              {value ? (
                <CheckIcon className="w-4 h-4 text-[#3662E3] mr-2 mt-0.5" />
              ) : (
                <XMarkIcon className="w-4 h-4 text-gray-400 mr-2 mt-0.5" />
              )}
              <span>
              {typeof value === 'boolean'
                  ? key
                  : `${key}`}
              </span>
            </li>
          ))}
        </ul>

        {/* Line below features */}
        <div className="w-full h-[0.8px] bg-[#4A5567] mt-4"></div>

        {/* Button */}
       {isAdminCreated?null: !isCancelled?
        <button onClick={onCancel} className="w-2/3 mx-auto mt-6 py-2 px-3 rounded-lg text-sm border text-white bg-[#3662E3] border-[#3662E3] font-medium transition-colors duration-300 ">
          {"Cancel Subscription"}
        </button>
        :
        <button className="w-3/5 mx-auto mt-6 py-2 px-3 rounded-lg text-sm hover:cursor-none text-white bg-[#3662E3] border-[#3662E3] font-medium transition-colors duration-300 ">
          {"Subscribed"}
        </button>
        }
      </div>
    </div>
    :
    <div onClick={onClick} className="flex flex-col justify-between min-h-[550px] hover:border-[#3662E3] hover:border-2 bg-[#212C43] border border-[#4A5567] rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg hover:scale-[1.02] hover:-translate-y-1">
      <div className="p-4 md:p-6 md:py-8 flex flex-col flex-1 text-center">
        {/* Header */}
        <div className="mb-4">
          <h3 className="text-xs font-semibold text-white bg-[#3662E3] px-3 py-1 rounded-full inline-block">{plan.name}</h3>
        </div>

        {/* Price */}
        {plan.name !== 'Custom' ? (
          <div className="flex items-baseline justify-center mb-5 mt-2">
            <span className="text-4xl font-bold text-[#3662E3]">
              {plan.price === 0 ? '$0' : `$${plan.price}`}
            </span>
            <span className="text-xs text-gray-300 ml-1">
              {plan.interval === 'none' ? '' : `/${plan.interval}`}
            </span>
          </div>
        ) : (
          <div className="flex items-baseline justify-center mb-5 mt-2 h-[52px] flex items-center">
             <span className="text-2xl font-bold text-[#3662E3]">Contact Us</span>
          </div>
        )}

        {/* Line below price */}
        <div className="w-full h-[0.8px] bg-[#4A5567] mb-4"></div>

        {/* Features Heading */}
        <div className="mb-4">
          <h4 className="text-lg font-semibold text-white">Features</h4>
        </div>

        {/* Features */}
        <ul className="space-y-3 text-sm font-light  text-white  flex-1 overflow-y-auto pr-1">
          {featureList.map(([key, value]) => (
            <li key={key} className={`flex items-start justify-center ${value ? '' : 'opacity-50'}`}>
              {value ? (
                <CheckIcon className="w-4 h-4 text-[#3662E3] mr-2 mt-0.5" />
              ) : (
                <XMarkIcon className="w-4 h-4 text-gray-400 mr-2 mt-0.5" />
              )}
              <span>
              {typeof value === 'boolean'
                  ? key
                  : `${key}`}
              </span>
            </li>
          ))}
        </ul>

        {/* Line below features */}
        <div className="w-full h-[0.8px] bg-[#4A5567] mt-4"></div>

        {/* Button */}
   { isAdminCreated?null:    <button onClick={onClick} className="w-3/6 mx-auto mt-8 py-2 px-3 text-sm rounded-md border text-white bg-[#3662E3] border-[#3662E3] font-medium transition-colors duration-300 ">
          { plan.name === 'Custom' ? 'Contact Us' : (plan.price === 0 ? 'Get Started':!planeId?.length? 'Subscribe':isDownGrade?"Downgrade Plan": "Upgrade Plan") }
        </button>}
      </div>
    </div>
    
  );
};

export default PricingCard;





